import { makeStyles } from 'tss-react/mui';

interface IProps {
  error?: boolean;
}

const useStyles = makeStyles<IProps>()((theme, { error }) => ({
  root: {
    ...theme.typography.highlight1,
    '& .MuiInputBase-root': {
      color: theme.palette.background.contrastText,
      boxSizing: 'border-box',
      backgroundColor: 'transparent',
      width: '100%',
      ...theme.dimensions.inputs,
    },
    '& .MuiInputBase-input': {
      padding: '0',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border:
          '1px solid ' + (error ? theme.palette.error.main : theme.palette.background.contrastText),
      },
    },
    '& svg': {
      fill: theme.palette.background.contrastText,
    },
  },
  toolbar: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
}));

export default useStyles;
